export async function createPaymentSession(request) {
  const response = await fetch('/api/parking/payment-sessions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })

  const responseData = await response.json()

  if (!response.ok) {
    const detailsError =
      typeof responseData.details === 'string'
        ? responseData.details
        : responseData.details?.error
    throw new Error(responseData.error || detailsError || 'Failed to create payment session')
  }

  return responseData
}

export async function createTrafficPaymentSession(request) {
  const response = await fetch('/api/traffic/payment-sessions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })

  const responseData = await response.json()

  if (!response.ok) {
    const detailsError =
      typeof responseData.details === 'string'
        ? responseData.details
        : responseData.details?.error
    throw new Error(responseData.error || detailsError || 'Failed to create payment session')
  }

  return responseData
}
